import LinkedAccountConditionInputCombo from "./LinkedAccountConditionInputCombo";

export default LinkedAccountConditionInputCombo;
